import * as React from 'react';
import { UitkSpacing } from 'uitk-react-spacing';
export var FooterImageSection = function (_a) {
  var _b;
  var section = _a.section;
  if (!((_b = section === null || section === void 0 ? void 0 : section.sectionData) === null || _b === void 0 ? void 0 : _b.length)) {
    return null;
  }
  return React.createElement(UitkSpacing, {
    padding: {
      blockstart: 'three'
    }
  }, React.createElement("div", {
    className: "footer-image-list"
  }, section.sectionData.map(function (item) {
    if (item && item.type === 'link' && item.imgSrc && item.url) {
      return React.createElement(UitkSpacing, {
        padding: {
          block: 'two'
        },
        key: item.id
      }, React.createElement("a", {
        href: item.url
      }, React.createElement(UitkSpacing, {
        padding: {
          inline: 'three'
        }
      }, React.createElement("img", {
        src: item.imgSrc,
        alt: item.altText ? item.altText : item.url
      }))));
    }
    return null;
  })));
};